module.exports = __webpack_public_path__ + "img/cat-10.bc1261db.png";